'use client'

import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react'

type OnboardingExitContextValue = {
  exitHref: string | null
  beginExit: (href: string) => void
  endExit: () => void
}

const OnboardingExitContext = createContext<OnboardingExitContextValue | null>(
  null,
)

export const OnboardingExitProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [exitHref, setExitHref] = useState<string | null>(null)

  const value = useMemo(
    () => ({
      exitHref,
      beginExit: setExitHref,
      endExit: () => setExitHref(null),
    }),
    [exitHref],
  )

  return (
    <OnboardingExitContext.Provider value={value}>
      {children}
    </OnboardingExitContext.Provider>
  )
}

export const useOnboardingExit = () => {
  const context = useContext(OnboardingExitContext)
  if (!context) {
    return {
      exitHref: null,
      beginExit: () => undefined,
      endExit: () => undefined,
      isExiting: false,
    }
  }

  return {
    ...context,
    isExiting: context.exitHref != null,
  }
}
